import type { UIMessage } from "ai";

export type AssistantSocialPostPreviewReference = {
  scheduledPostId: string;
  ownerType: "campaign" | "standalone";
  ownerId: string;
  href: string | null;
};

export function getAssistantSocialPostPreviewReferences(
  message: Pick<UIMessage, "parts">,
): AssistantSocialPostPreviewReference[] {
  const references = new Map<string, AssistantSocialPostPreviewReference>();

  for (const part of message.parts) {
    const candidate = part as {
      type?: string;
      state?: string;
      output?: { posts?: unknown[] };
    };

    if (
      candidate.type !== "tool-list_social_post_previews" ||
      candidate.state !== "output-available" ||
      !Array.isArray(candidate.output?.posts)
    ) {
      continue;
    }

    for (const post of candidate.output.posts) {
      const reference = parseAssistantSocialPostPreviewReference(post);
      if (reference) {
        references.set(reference.scheduledPostId, reference);
      }
    }
  }

  return [...references.values()];
}

function parseAssistantSocialPostPreviewReference(
  value: unknown,
): AssistantSocialPostPreviewReference | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const post = value as {
    href?: unknown;
    render?: {
      component?: unknown;
      scheduledPostId?: unknown;
      ownerType?: unknown;
      ownerId?: unknown;
    };
  };
  const render = post.render;
  if (
    render?.component !== "instagram_post_preview" ||
    typeof render.scheduledPostId !== "string" ||
    !(render.ownerType === "campaign" || render.ownerType === "standalone") ||
    typeof render.ownerId !== "string"
  ) {
    return null;
  }

  return {
    scheduledPostId: render.scheduledPostId,
    ownerType: render.ownerType,
    ownerId: render.ownerId,
    href: getSafeAssistantSocialPostPreviewHref(post.href),
  };
}

function getSafeAssistantSocialPostPreviewHref(href: unknown): string | null {
  if (typeof href !== "string") {
    return null;
  }

  return href === "/app" || href.startsWith("/app/") ? href : null;
}
